var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-card',{staticClass:"tab"},[_c('v-card-title',[_vm._t("tabs")],2),_c('div',{staticClass:"padding-30"},[_vm._t("form")],2)],1),_c('br'),_c('div',{staticClass:"text-right"},[_vm._t("buttons")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }